import { useRef, useEffect } from "react";
import {
  setIntersectionObserver,
  unsetIntersectionObserver,
} from "../utils/setIntersectionObserver";

const useFiftyPercentInView = (callback) => {
  const observer = useRef(null);
  const element = useRef(null);

  const refCallback = (node) => {
    if (observer.current) {
      unsetIntersectionObserver(element.current, observer.current);
      observer.current = null;
    }

    if (node) {
      element.current = node;
      observer.current = setIntersectionObserver({
        element: node,
        options: {
          threshold: 0.5,
        },
        handleIntersectionData: ({ isIntersecting }) => {
          if (isIntersecting) callback();
        },
        observeIntersectionOnce: true,
      });
    }
  };

  useEffect(
    () => () => {
      unsetIntersectionObserver(element.current, observer.current);
    },
    []
  );

  return refCallback;
};

export default useFiftyPercentInView;
